import { styled } from 'styled-components';

import { PRESETS_MAX_HEIGHT, RANGE_PRESET_MIN_WIDTH, TIME_PRESET_MIN_WIDTH } from './constants.ts';

export const Header = styled.div`
  padding: 10px 16px;
  font-weight: 500;
  ${({ theme }) => theme.typography.textMedium};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
`;

export const MobileHeader = styled.div`
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme }) => theme.colors.grey100_1};
  margin-bottom: 4px;
`;

export const PresetsWrapper = styled.div`
  max-height: ${PRESETS_MAX_HEIGHT}px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const Preset = styled.div<{ $isActive?: boolean; $isCustom?: boolean; $range?: boolean }>`
  min-width: ${({ $range }) => `${$range ? RANGE_PRESET_MIN_WIDTH : TIME_PRESET_MIN_WIDTH}px`};
  padding: 10px 16px;
  ${({ theme }) => theme.typography.textMedium};
  display: flex;
  justify-content: space-between;
  gap: 4px;
  cursor: ${({ $isCustom }) => ($isCustom ? 'default' : 'pointer')};
  background-color: ${({ theme, $isActive }) => $isActive && theme.colors.grey05_1};

  &:hover {
    background-color: ${({ theme: { colors }, $isCustom }) => ($isCustom ? colors.grey00_1 : colors.grey05_1)};
  }
`;
